import { Dispatch, MutableRefObject, SetStateAction } from "react"
import ReactModal from "react-modal"

type MatrixLabelEditorModalProps = {
  appContainer: HTMLDivElement | null | undefined
  isOpen: boolean
  setOpen: Dispatch<boolean>
  matrixLabelInputRef: MutableRefObject<HTMLInputElement | null>
  matrixLabel: string
  setMatrixLabel: Dispatch<SetStateAction<string>>
  handleConfirmMatrixLabel: () => void
}

export const MatrixLabelEditorModal = (props: MatrixLabelEditorModalProps) => {
  const {
    appContainer,
    isOpen,
    setOpen,
    matrixLabelInputRef,
    matrixLabel,
    setMatrixLabel,
    handleConfirmMatrixLabel,
  } = props

  return (
    <ReactModal
      appElement={appContainer || undefined}
      isOpen={isOpen}
      onRequestClose={() => setOpen(false)}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 250,
          height: 80,
          padding: 10,
          zIndex: 10,
          border: "1px solid #dfdfdf",
        },
        overlay: {
          zIndex: 10,
          background: "rgba(0,0,0,0.1)",
        },
      }}
    >
      <div>Label</div>
      <input
        ref={matrixLabelInputRef}
        style={{ border: "1px solid #484848" }}
        value={matrixLabel}
        onChange={({ target }) => {
          setMatrixLabel(target.value)
        }}
      />
      <button
        onClick={handleConfirmMatrixLabel}
        className="api-button"
        style={{ marginLeft: 10 }}
      >
        Confirm
      </button>
    </ReactModal>
  )
}
